import { ClassroomFeatureFlags, defaultClassroomFlags } from "../../../storez/ClassroomFeatureFlagStore";
import { ClassroomFeatureFlagRequest, ClassroomFeatureFlagResponse } from "../../../utils/api/ClassroomFeatureFlags";

export function convertArrayToFeatureFlags(features: ClassroomFeatureFlagResponse[]): ClassroomFeatureFlags {
  const flags = defaultClassroomFlags;
  flags.usernamePasswordLogins = features.includes(ClassroomFeatureFlagResponse.UsernamePasswordLogin);
  flags.screenShare = features.includes(ClassroomFeatureFlagResponse.ScreenShare);
  flags.schoolAssociations = features.includes(ClassroomFeatureFlagResponse.SchoolAssociations);
  flags.scheduledClassesV2 = features.includes(ClassroomFeatureFlagResponse.ScheduledClassesV2);
  return flags;
}

export function convertFeatureFlagsToArrayForApiRequest(flags: ClassroomFeatureFlags): ClassroomFeatureFlagRequest[] {
  const features: ClassroomFeatureFlagRequest[] = [];

  if (flags.screenShare) {
    features.push(ClassroomFeatureFlagRequest.ScreenShare);
  }

  if (flags.schoolAssociations) {
    features.push(ClassroomFeatureFlagRequest.SchoolAssociations);
  }

  if (flags.usernamePasswordLogins) {
    features.push(ClassroomFeatureFlagRequest.UsernamePasswordLogin);
  }

  return features;
}
